export default __webpack_public_path__ + "static/media/sman 11 jakarta.cb63869e.png";